import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { QuoteTrackingService } from '../../quote-tracking.service'
import { Observable } from 'rxjs'
import { DeliveryAddress } from '../../../quote-checkout/model/address-models'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { Actions, ofType } from '@ngrx/effects'
import { LaunchDialogService } from '@spartacus/storefront'
import { filter, take } from 'rxjs/operators'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { CartActions } from '@spartacus/cart/base/core'
import { BreadcrumbService } from '../../../../../shared/components/breadcrumb/breadcrumb.service'
import { SpinnerOverlayService } from '../../../../../shared/components/spinner-overlay/spinner-overlay.service'
import {
  CurrentQuoteStatus,
  QuoteStatus,
} from '../../../../../models/status/status.model'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-merge-quote',
  templateUrl: './merge-quote.component.html',
  styleUrls: ['./merge-quote.component.scss'],
})
export class MergeQuoteComponent implements OnInit {
  public active: string
  expandAll = false
  maxLength = 3
  lineItems = []
  quoteObjects = []
  quoteDetailsData: any
  shipToAddress: DeliveryAddress
  billToAddress: DeliveryAddress
  cart
  endUserAddress: DeliveryAddress
  rfqTypeArr = []
  dateObject: any
  quantityErrMsg: boolean = false
  quoteDetails
  isOrderCreated: boolean = false
  totalMergeItemChecked: number = 0
  constructor(
    private breadCrumbService: BreadcrumbService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private quoteTrackingService: QuoteTrackingService,
    private multiCartService: MultiCartFacade,
    private actions$: Actions,
    private spinnerOverlayService: SpinnerOverlayService,
    private globalMessageService: GlobalMessageService,
    private launchDialogService: LaunchDialogService,
    private translate: TranslationService,
    protected cartService: ActiveCartFacade
  ) {}
  public quoteArray$: Observable<any>
  public quoteArray
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.dateObject = params
    })

    this.translate
      .translate('quoteTracking.quoteStatus')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadCrumbs([
          {
            label: res,
            link: '/quote-list',
          },
        ])
      )

    this.translate
      .translate('quoteTracking.mergeQuote')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )
    this.quoteTrackingService.getQuoteDetailsForMerge.subscribe((details) => {
      this.quoteDetails = details
      if (this.quoteDetails?.isQuoteToOrderCreated == true)
        this.isOrderCreated = this.quoteDetails?.isQuoteToOrderCreated
    })
    this.quoteArray$ = this.quoteTrackingService.getQuotesForMerge
    this.quoteArray$.subscribe((quotes) => {
      this.quoteArray = quotes
      this.active = this.quoteArray[0]?.quoteId
      this.quoteObjects = []
    })
    this.cartService.getActive().subscribe(
      (success) => {
        this.cart = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  updateActiveCard(event) {
    this.active = event
  }
  navigateToDetails() {
    this.router.navigate(['quote-list'])
  }
  getQuoteCards() {
    return Array(this.maxLength - this.quoteArray.length)
  }
  deleteCard(event) {
    this.quoteArray.splice(event, 1)
  }
  getQuoteLineDetails(event) {
    if (event?.quoteId) {
      event.quoteDetailsData?.quoteLineDetails.forEach((element) => {
        if (element.quantity == 0) {
          this.quantityErrMsg = true
          return
        }
        if (
          element.quoteStatusCode === CurrentQuoteStatus.OPEN &&
          element.isOrderCreated == false
        ) {
          let lineItem = {
            brandCode: '',
            brandName: '',
            code: '',
            comment: '',
            csrResponseRequired: true,
            customerRequestedDate: '',
            assignedShipDate: '',
            discountValues: [],
            priceAdderData: [],
            isUnsolicited: true,
            productType: '',
            quantity: 0,
            quoteCartEntryType: '',
            quoteExtendedPrice: 0,
            quoteNetPrice: 0,
            listPrice: 0,
            reasonForQuote: '',
            rfqPartDescription: '',
            rfqPartNumber: '',
            serialNumber: '',
            tagNumber: '',
            sapQuoteID: '',
            itemNumber: '',
            netP: '',
            zumuPrice: '',
            isChecked: false,
            entryType: '',
            customerMaterialNumber: ''
          }
          lineItem = {
            csrResponseRequired: true,
            brandCode: 'MASONEILAN',
            brandName: 'MASONEILAN',
            comment: element.additionalComments,
            customerRequestedDate: element.requestedShipDate.replace(/-/g, '/'),
            assignedShipDate: element.newDeliveryDate.replace(/-/g, '/'),
            code: element.partNumber,
            discountValues: element.discountValues,
            priceAdderData: element?.priceAdderData,
            isUnsolicited: true,
            productType: 'Part',
            quantity: Number(element.quantity),
            reasonForQuote: '',
            quoteExtendedPrice: Number(element?.quoteExtendedPrice),
            quoteNetPrice: Number(element?.quoteNetPrice),
            listPrice: Number(element?.listPrice),
            rfqPartDescription: element.partDescription,
            serialNumber: element.serialNumber,
            rfqPartNumber: element.partNumber,
            tagNumber: element.tagNumber,
            quoteCartEntryType: QuoteStatus.MERGE,
            sapQuoteID: event.quoteId,
            itemNumber: element.itemNumber,
            netP: element.netP,
            zumuPrice: element.zumuPrice,
            isChecked: false,
            entryType: element?.entryType,
            customerMaterialNumber: element?.customerMaterialNumber
          }
          this.lineItems.push(lineItem)
        }
      })
      var ship =
        event.quoteDetailsData.quoteDetailsList.shipToAddress.split(';')
      this.shipToAddress = {
        partnerNumber: ship[0],
        companyName: ship[1],
        line1: ship[3],
        line2: ship[2],
        town: ship[4],
        region: {
          isocode: ship[7] + '-' + ship[6],
        },
        country: {
          isocode: ship[7],
        },
        postalCode: ship[8],
      }
      var sold =
        event.quoteDetailsData.quoteDetailsList.soldToAddress.split(';')
      this.billToAddress = {
        companyName: sold[0],
        line1: sold[2],
        line2: sold[1],
        town: sold[3],
        region: {
          isocode: sold[6] + '-' + sold[5],
        },
        country: {
          isocode: sold[6],
        },
        postalCode: sold[7],
      }
      var end =
        event.quoteDetailsData.quoteDetailsList.endUserAddresss.split(';')
      this.endUserAddress = {
        partnerNumber: end[0],
        companyName: end[1],
        line1: end[3],
        line2: end[2],
        town: end[4],
        region: {
          isocode: end[7] + '-' + end[6],
        },
        country: {
          isocode: end[7],
        },
        postalCode: end[8],
      }

      var quoteObject = {
        billToAddress: this.billToAddress,
        deliveryAddress: this.shipToAddress,
        endUserAddress: this.endUserAddress,
        quoteCartType: QuoteStatus.MERGE,
        quoteEntries: this.lineItems,
        quoteId: event?.quoteId,
        contactNumber: null,
        customerProjectName:
          event.quoteDetailsData?.quoteDetailsList?.customerProjectName,
        endUserIndustry:
          event.quoteDetailsData?.quoteDetailsList?.endUserIndustry,
        notificationEmail:
          event.quoteDetailsData?.quoteDetailsList?.notificationEmail,
        customerReviewCheck: null,
        hasRestrictedUse: null,
        isNuclear: null,
        legalEntity: null,
        requiresExportLicense: null,
        restrictedCountryCheck: null,
        rfqType: event.quoteDetailsData?.quoteDetailsList?.rfqType,
        sanctionCheck: null,
      }
      this.quoteObjects.push(quoteObject)
      this.lineItems.forEach((element) => {
        this.rfqTypeArr.push(element.itemNumber + '|' + element?.sapQuoteID)
      })
      this.lineItems = []
    } else if (event?.code) {
      let selectedQuoteId = sessionStorage.getItem('selectedQuoteId');      
      
      this.quoteObjects.forEach((item) => {
        if (item?.quoteEntries.length > 0) {
          item.quoteEntries.filter((qitem) => {
            if (qitem.code === event.code && selectedQuoteId === qitem.sapQuoteID && qitem.itemNumber === event.itemNumber) {
              qitem.isChecked = event.checked
            }
          })
        }
      })

      this.checkAcceptCheckoutEnable()
    }
  }

  checkAcceptCheckoutEnable() {
    this.totalMergeItemChecked = 0
    this.quoteObjects.forEach((item) => {
      item.quoteEntries.filter((mitem) => {
        if (mitem.isChecked) {
          this.totalMergeItemChecked++
        }
      })
    })
  }
  mergeQuoteConfirmPrompt() {
    const componentdata = {
      mergeQuoteMsg: true,
    }
    const mergeQuoteEditDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.MERGE_QUOTE_EDIT,
      undefined,
      undefined,
      componentdata
    )
    if (mergeQuoteEditDialog) {
      mergeQuoteEditDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.MERGE_QUOTE_EDIT
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason === 'merge-quote') {
            this.mergeQuote()
          } else {
          }
        })
    }
  }

  openMergeModal() {
    if (this.cart?.entries?.length > 0 || this.quantityErrMsg) {
      const componentdata = {
        warningMsg: this.quantityErrMsg,
      }

      const mergeQuoteEditDialog = this.launchDialogService.openDialog(
        VS_LAUNCH_CALLER.MERGE_QUOTE_EDIT,
        undefined,
        undefined,
        componentdata
      )
      if (mergeQuoteEditDialog) {
        mergeQuoteEditDialog.pipe(take(1)).subscribe((value) => {})
        this.launchDialogService.dialogClose
          .pipe(
            filter(
              (dialogResponse: DialogResponse) =>
                dialogResponse?.type == VS_LAUNCH_CALLER.MERGE_QUOTE_EDIT
            ),
            take(1)
          )
          .subscribe((value) => {
            if (value?.reason === 'merge-quote-edit') {
              this.mergeQuoteConfirmPrompt()
            } else {
            }
          })
      }
    } else {
      this.mergeQuoteConfirmPrompt()
    }
  }
  mergeQuote() {
    this.spinnerOverlayService.show()

    const mergeQuoteObj = this.quoteObjects.map((item) => ({
      ...item,
      quoteEntries: item.quoteEntries
        ? item.quoteEntries
            .filter((x) => x.isChecked)
            .map(({ isChecked, ...rest }) => rest)
        : [],
    }))

    this.quoteTrackingService.mergeQuote(mergeQuoteObj).subscribe(
      (success) => {
        sessionStorage.setItem('itemNumber', this.rfqTypeArr.toString())
        this.spinnerOverlayService.hide()
        this.multiCartService.loadCart({
          userId: 'current',
          cartId: success['code'],
          extraData: {
            active: true,
          },
        })
        // this.router.navigate(['cartCheckout']);
        this.actions$
          .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
          .subscribe((success) => {
            this.quoteTrackingService.setQuotesForMerge([])
            this.router.navigate(['cart/checkout'])
          })
      },
      (error) => {
        this.spinnerOverlayService.hide()
        this.globalMessageService.add(
          { key: 'quoteTracking.errorOccuredMergingQuotes' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
}
